// No frontend-specific logic needed for language-tab block
// The parent language-tabs block handles all interactivity
